export const TIPOS_MOVIMIENTO_BODEGA = {
  SALDO_INICIAL: {
    etiqueta: 'Saldo inicial',
    clase: 'bg-blue-100 text-blue-700',
  },
  ENTRADA: {
    etiqueta: 'Entrada',
    clase: 'bg-emerald-100 text-emerald-700',
  },
  SALIDA: {
    etiqueta: 'Salida',
    clase: 'bg-amber-100 text-amber-700',
  },
  TRANSFERENCIA: {
    etiqueta: 'Transferencia',
    clase: 'bg-slate-100 text-slate-700',
  },
}

export const ESTADOS_STOCK = {
  disponible: {
    etiqueta: 'Disponible',
    clase: 'bg-emerald-100 text-emerald-700',
  },
  stock_bajo: {
    etiqueta: 'Stock bajo',
    clase: 'bg-amber-100 text-amber-700',
  },
  sin_stock: {
    etiqueta: 'Sin stock',
    clase: 'bg-slate-100 text-slate-600',
  },
}

export function obtenerTipoMovimiento(valor) {
  return (
    TIPOS_MOVIMIENTO_BODEGA[valor] || {
      etiqueta: valor || 'Sin tipo',
      clase: 'bg-slate-100 text-slate-600',
    }
  )
}

export function formatearTipoMovimiento(valor) {
  return obtenerTipoMovimiento(valor).etiqueta
}

export function obtenerEstadoStock(saldo, stockBajo) {
  const cantidad = Number(saldo) || 0

  if (cantidad <= 0) return ESTADOS_STOCK.sin_stock
  if (stockBajo) return ESTADOS_STOCK.stock_bajo

  return ESTADOS_STOCK.disponible
}

export function formatearCantidadBodega(valor) {
  const numero = Number(valor)

  if (!Number.isFinite(numero)) return '0'

  return numero.toLocaleString('es-CL', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  })
}

export function formatearFechaBodega(fechaTexto) {
  if (!fechaTexto) return '—'

  const [anio, mes, dia] = fechaTexto.split('-')

  if (!anio || !mes || !dia) return '—'

  return `${dia}-${mes}-${anio}`
}

export function obtenerFechaActualBodega() {
  const fecha = new Date()
  const anio = fecha.getFullYear()
  const mes = String(fecha.getMonth() + 1).padStart(2, '0')
  const dia = String(fecha.getDate()).padStart(2, '0')

  return `${anio}-${mes}-${dia}`
}
